import { DatePipe, formatDate } from '@angular/common';
import { NgModule } from '@angular/core';

export class SerialUser {
  id: number;
  serial: string;
  userId: number;
  dateStart?: Date;
  descriptionShort?: string;
  descriptionLong?: string;

  constructor() {
    (this.id = -1), (this.serial = ''), (this.userId = -1);
    //  (this.dateStart = new Date(formatDate(Date.now(), 'yyyy-MM-dd', 'en-US')));
  }
}
